import { render, staticRenderFns } from "./draggableTable.vue?vue&type=template&id=5b4faaf0&scoped=true"
import script from "./draggableTable.vue?vue&type=script&lang=js"
export * from "./draggableTable.vue?vue&type=script&lang=js"
import style0 from "./draggableTable.vue?vue&type=style&index=0&id=5b4faaf0&prod&scoped=true&lang=css"
import style1 from "./draggableTable.vue?vue&type=style&index=1&id=5b4faaf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4faaf0",
  null
  
)

export default component.exports